export default "/images/vendor/flag-icon-css/flags/1x1/gm.svg?65c86e0a8df296521d901a6c76f801d8";